import Image from 'next/image';
import { Page } from '@/payload/payload-types';
import RichTextLexical from '../../_components/RichTextLexical';
import Typography from '../../_components/Typography';
import { CtaButton } from '../CtaButton';

type CtaBannerType = Extract<Page['layoutBlocks'][0], { blockType: 'ctaBanner' }>;
type CtaBannerProps = Omit<CtaBannerType, 'blockType'>;

export const CtaBanner: React.FC<CtaBannerProps> = ({
	ctaBannerAppearance,
	ctaBannerTitle,
	ctaBannerDescription,
	ctaBannerButton,
	ctaBannerImage,
	enableCtaBannerImage,
}) => {
	if (typeof ctaBannerImage === 'string') {
		throw new Error('Something went wrong. Bad image depth for hero image.');
	}
	const ctaImage = enableCtaBannerImage && ctaBannerImage?.sizes?.hero; // todo: make correct size once design has arrived
	const isFullWidth = ctaBannerAppearance === 'full width';

	if (!ctaBannerTitle) return null;

	return (
		<div className={`relative flex flex-col`}>
			{isFullWidth && (
				<div className="full-width-bg bg-gold-light-8 absolute top-0 z-0 h-full" />
			)}
			<div
				className={`relative flex w-full flex-col md:flex-row ${!isFullWidth ? 'rounded-[32px]' : ''} bg-gold-light-8 px-8 py-10 md:px-40 md:py-20 ${ctaImage ? `${isFullWidth ? 'lg:pl-0' : 'space-y-4 md:space-y-0'} space-y-4 md:space-y-0` : 'justify-center'} z-10 items-center md:space-x-14`}
			>
				{ctaImage && (
					<Image
						className="rounded-3xl"
						width={200}
						height={200}
						alt={ctaBannerImage.alt}
						src={ctaImage.url || '/assets/no-image.png'}
						priority
					/>
				)}
				<div
					className={`${ctaImage ? 'items-center md:items-start' : 'items-center'} flex flex-col`}
				>
					<Typography.Large useOnlyStyles bold>
						<RichTextLexical content={ctaBannerTitle} />
					</Typography.Large>
					{ctaBannerDescription && (
						<RichTextLexical className="mt-4" content={ctaBannerDescription} />
					)}
					<CtaButton className="mt-6" ctaButton={ctaBannerButton} />
				</div>
			</div>
		</div>
	);
};
